import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';

import { CalculateFestivalEssDto } from './dto.type';

export class CalculateFestivalEssMapper {
  static dtoToEntity(dto: CalculateFestivalEssDto): CalculateFestivalEss {
    return {
      scoreLetter: getScoreLetterFromScore(dto.score / dto.maxScore),
      score: dto.score,
      maxScore: dto.maxScore,
      topics: {
        PARITY_EQUALITY: {
          score: dto.topics.PARITY_EQUALITY.score,
          maxScore: dto.topics.PARITY_EQUALITY.maxScore,
          sections: {
            ARTISTIC_TEAM: {
              score: dto.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM.score,
              maxScore:
                dto.topics.PARITY_EQUALITY.sections.ARTISTIC_TEAM.maxScore,
            },
            PERMANENT_OPERATIONAL_TEAM: {
              score:
                dto.topics.PARITY_EQUALITY.sections.PERMANENT_OPERATIONAL_TEAM
                  .score,
              maxScore:
                dto.topics.PARITY_EQUALITY.sections.PERMANENT_OPERATIONAL_TEAM
                  .maxScore,
            },
            OCCASIONAL_OPERATIONAL_TEAM: {
              score:
                dto.topics.PARITY_EQUALITY.sections.OCCASIONAL_OPERATIONAL_TEAM
                  .score,
              maxScore:
                dto.topics.PARITY_EQUALITY.sections.OCCASIONAL_OPERATIONAL_TEAM
                  .maxScore,
            },
            TRANSPARENCY_MANAGEMENT: {
              score:
                dto.topics.PARITY_EQUALITY.sections.TRANSPARENCY_MANAGEMENT
                  .score,
              maxScore:
                dto.topics.PARITY_EQUALITY.sections.TRANSPARENCY_MANAGEMENT
                  .maxScore,
            },
          },
        },
        ACCESSIBILITY_SOCIAL_DIALOGUE: {
          score: dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
          maxScore: dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
          sections: {
            ACCESSIBILITY: {
              score:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections.ACCESSIBILITY
                  .score,
              maxScore:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections.ACCESSIBILITY
                  .maxScore,
            },
            RISK_PREVENTION: {
              score:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                  .RISK_PREVENTION.score,
              maxScore:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                  .RISK_PREVENTION.maxScore,
            },
            VOLUNTEERS: {
              score:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections.VOLUNTEERS
                  .score,
              maxScore:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections.VOLUNTEERS
                  .maxScore,
            },
            COMMUNICATION: {
              score:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections.COMMUNICATION
                  .score,
              maxScore:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections.COMMUNICATION
                  .maxScore,
            },
            TEAM_MANAGEMENT: {
              score:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                  .TEAM_MANAGEMENT.score,
              maxScore:
                dto.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.sections
                  .TEAM_MANAGEMENT.maxScore,
            },
          },
        },
        LOCAL_IMPACT_RSE_ENGAGEMENT: {
          score: dto.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
          maxScore: dto.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
          sections: {
            LOCALITY_EMPLOYMENT_PARTNERS: {
              score:
                dto.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                  .LOCALITY_EMPLOYMENT_PARTNERS.score,
              maxScore:
                dto.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                  .LOCALITY_EMPLOYMENT_PARTNERS.maxScore,
            },
            ECONOMIC_SOCIAL_IMPACT: {
              score:
                dto.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                  .ECONOMIC_SOCIAL_IMPACT.score,
              maxScore:
                dto.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.sections
                  .ECONOMIC_SOCIAL_IMPACT.maxScore,
            },
          },
        },
      },
      sectors: {
        ANY: {
          score: 0,
          maxScore: 0,
        },
        ARTISTS: {
          score: dto.sectors.artists.score,
          maxScore: dto.sectors.artists.maxScore,
        },
        PUBLIC: {
          score: dto.sectors.public.score,
          maxScore: dto.sectors.public.maxScore,
        },
        SITE: {
          score: dto.sectors.site.score,
          maxScore: dto.sectors.site.maxScore,
        },
        TEAM: {
          score: dto.sectors.team.score,
          maxScore: dto.sectors.team.maxScore,
        },
      },
    };
  }
}
